// frontend/src/routes.js
// ✅ CON MÓDULO DE FACTURACIÓN Y FACILITACIÓN + PERMISOS CORRECTOS

import Dashboard from './pages/Dashboard/Dashboard';
import QuoteInbox from './pages/Inbox/QuoteInbox';
import OrderInbox from './pages/Inbox/OrderInbox';
import QuotesList from './pages/Quotes/QuotesList';
import QuoteDetail from './pages/Quotes/QuoteDetail';
import OrdersList from './pages/Orders/OrdersList';
import OrderDetail from './pages/Orders/OrderDetail';
import ClientsList from './pages/Clients/ClientsList';
import ClientDetail from './pages/Clients/ClientDetail';
import Finance from './pages/Finance/Finance';
import InvoiceInbox from './pages/Finance/InvoiceInbox';
import CashflowDashboard from './pages/Finance/CashflowDashboard';
import SalesAnalysis from './pages/Finance/SalesAnalysis';
import FacilitationList from './pages/Facilitation/FacilitationList';
import FacilitationDetail from './pages/Facilitation/FacilitationDetail';
import PendingFacilitationDetail from './pages/Facilitation/PendingFacilitationDetail';
import UserManagement from './pages/Admin/UserManagement';
import FacilitatorsManagement from './pages/Admin/FacilitatorsManagement';
import SellersManagement from './pages/Admin/SellersManagement';
import SellerDetail from './pages/Admin/SellerDetail'; 

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'ni ni-tv-2 text-primary',
    component: Dashboard,
    layout: '/admin',
    permission: 'view_dashboard',
  },
  {
    name: 'Propuestas',
    icon: 'ni ni-single-copy-04 text-info',
    state: 'quotesCollapse',
    submenu: [
      {
        path: '/inbox/quotes',
        name: 'Nueva Propuesta',
        miniName: 'N',
        component: QuoteInbox,
        layout: '/admin',
        permission: 'upload_quotes',
      },
      {
        path: '/quotes',
        name: 'Todas',
        miniName: 'T',
        component: QuotesList,
        layout: '/admin',
        permission: 'view_quotes',
      },
    ],
  },
  {
    name: 'Órdenes de compra',
    icon: 'ni ni-bag-17 text-success',
    state: 'ordersCollapse',
    submenu: [
      {
        path: '/inbox/orders',
        name: 'Nueva orden',
        miniName: 'N',
        component: OrderInbox,
        layout: '/admin',
        permission: 'upload_orders',
      },
      {
        path: '/orders',
        name: 'Todas',
        miniName: 'T',
        component: OrdersList,
        layout: '/admin',
        permission: 'view_orders',
      },
    ],
  },
  {
    path: '/clients',
    name: 'Clientes',
    icon: 'ni ni-briefcase-24 text-purple',
    component: ClientsList,
    layout: '/admin',
    permission: 'view_clients',
  },
  {
    path: '/facilitation',
    name: 'Facilitación',
    icon: 'ni ni-hat-3 text-success',
    component: FacilitationList,
    layout: '/admin',
    permission: 'view_facilitation',
  },
  {
    name: 'Facturación',
    icon: 'ni ni-money-coins text-orange',
    state: 'financeCollapse',
    submenu: [
      {
        path: '/finance',
        name: 'Dashboard',
        miniName: 'D',
        component: Finance,
        layout: '/admin',
        permission: 'view_finance',
      },
      {
        path: '/finance/inbox',
        name: 'Nueva factura',
        miniName: 'N',
        component: InvoiceInbox,
        layout: '/admin',
        permission: 'view_finance',
      },
      {
        path: '/finance/cashflow',
        name: 'Cobro y Cashflow',
        miniName: 'C',
        component: CashflowDashboard,
        layout: '/admin',
        permission: 'view_cashflow',
      },
      {
        path: '/finance/analysis',
        name: 'Análisis de Ventas',
        miniName: 'A',
        component: SalesAnalysis,
        layout: '/admin',
        permission: 'view_sales_analysis',
      },
    ],
  },
  {
    name: 'Administración',
    icon: 'ni ni-settings-gear-65 text-dark',
    state: 'adminCollapse',
    permission: 'manage_users',
    submenu: [
      {
        path: '/users',
        name: 'Usuarios',
        miniName: 'U',
        component: UserManagement,
        layout: '/admin',
        permission: 'manage_users',
      },
      {
        path: '/facilitators',
        name: 'Facilitadores',
        miniName: 'F',
        component: FacilitatorsManagement,
        layout: '/admin',
        permission: 'manage_users',
      },
      {
        path: '/sellers',
        name: 'Account Managers',
        miniName: 'A',
        component: SellersManagement,
        layout: '/admin',
        permission: 'manage_users',
      },
    ],
  },
  
  // ============================================
  // RUTAS OCULTAS (para detalles)
  // ============================================
  {
    path: '/quotes/:id',
    name: 'Detalle de Cotización',
    component: QuoteDetail,
    layout: '/admin',
    hidden: true,
    permission: 'view_quotes',
  },
  {
    path: '/orders/:id',
    name: 'Detalle de Orden',
    component: OrderDetail,
    layout: '/admin',
    hidden: true,
    permission: 'view_orders',
  },
  {
    path: '/clients/:id',
    name: 'Detalle de Cliente',
    component: ClientDetail,
    layout: '/admin',
    hidden: true,
    permission: 'view_clients',
  },
    {
      path: '/facilitation/pending/:id',
      name: 'Facilitación Pendiente OC',
      component: PendingFacilitationDetail,
      layout: '/admin',
      hidden: true,
      permission: 'view_facilitation',
    },
    {
      path: '/facilitation/:id',
      name: 'Detalle de Facilitación',
      component: FacilitationDetail,
      layout: '/admin',
      hidden: true,
      permission: 'view_facilitation',
    },
    {
    path: '/sellers/:id',  // 🆕 NUEVO
    name: 'Detalle de Account Manager',
    component: SellerDetail,
    layout: '/admin',
    hidden: true,
    permission: 'manage_users',
  },

];

export default routes;
